module.exports = __webpack_public_path__ + "components/roadsurfer/static/roadsurfer-1600-e411df9355fe552c1037de8c14b9a2fb.webp";